var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sweet-modal",
    { ref: "modal", attrs: { "overlay-theme": "dark" } },
    [
      _vm.professional
        ? _c("div", [
            _c(
              "div",
              { staticClass: "text-left p-3 text-comment" },
              [
                _c("cleaner-profile-mobile", {
                  attrs: {
                    isActiveReviewLink: false,
                    professional: _vm.professional
                  }
                }),
                _vm._v(" "),
                _c("cleaner-description-section", {
                  attrs: { professional: _vm.professional }
                }),
                _vm._v(" "),
                _c("hr", { staticClass: "mb-0" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pt-4" },
                  [
                    _c("cleaner-reviews-section", {
                      ref: "professionalReviews"
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "modal-footer-test bg-white border-top py-3 text-right"
              },
              [
                _vm.isLoading
                  ? _c(
                      "div",
                      {
                        staticClass: "alert alert-info text-left",
                        attrs: { role: "alert" }
                      },
                      [
                        _c("h4", { staticClass: "mb-0" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "message.booking.switch_professional.processing_switch_professional"
                                )
                              ) +
                              "\n          "
                          ),
                          _c("span", { staticClass: "text-info" }, [
                            _c("i", { staticClass: "fas fa-spinner fa-pulse" })
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info btn-block",
                    attrs: { disabled: _vm.isLoading },
                    on: { click: _vm.displayConfirmDialog }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.isLoading
                            ? _vm.$t("message.button.loading")
                            : _vm.$t(
                                "message.booking.switch_professional.button"
                              )
                        ) +
                        "\n      "
                    )
                  ]
                )
              ]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48c80c0d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48c80c0d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/components/ProfessionalDetailModal.vue
// module id = 1624
// module chunks = 0